import styled, { css } from 'styled-components/macro'
import PropTypes from 'prop-types'
import { ifProp, theme } from 'styled-tools'
import { em, rem } from '../../../utils/styles'

const fontSize = em(16)
const padding = css`${rem(10)} ${rem(14)}`
const border = css`${rem(1)} solid ${theme('colors.medium')}`
const weight = theme('fontWeights.regular')
const color = theme('colors.base')

const focusBg = theme('colors.base')
const hoverColor = '#fff'
const highlightedBg = ifProp('isHighlighted', css`
  background-color: ${theme('colors.light')};
`)

const OptionItem = styled.li`
  display: block;
  box-sizing: border-box;
  margin: 0;
  border: 0;
  padding: ${padding};
  width: 100%;
  background: none;
  color: ${color};
  font-weight: ${weight};
  font-size: ${fontSize};
  vertical-align: middle;
  line-height: 1;
  text-align: left;
  overflow: visible;

  &:disabled {
    opacity: .7;
    cursor: not-allowed;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &:focus {
    outline: 0;
  }

  &:not(:disabled) {
    &:focus {
      background-color: ${focusBg};
    }

    &:hover {
      background-color: ${focusBg};
      color: ${hoverColor};
    }
  }

  * + & {
    border-top: ${border};
  }

  &:not(:disabled) {
    ${highlightedBg}
  }
`

OptionItem.propTypes = {
  isHighlighted: PropTypes.bool
}

export default OptionItem
